import { makeRequest } from 'utils/requestLogger';

export default (poll_id, payload) =>
  makeRequest('put', `/api/polls/${poll_id}/edit`, payload);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/editPoll.js